import { IResourceComponentsProps } from '@refinedev/core';
import { AntdInferencer } from '@refinedev/inferencer/antd';

export const KycLv2Edit: React.FC<IResourceComponentsProps> = () => {
  return <AntdInferencer />;
};
